import { Component, input, OnInit, output, inject } from '@angular/core';
import { LocalizationService } from '@abp/ng.core';
import {
  AngularSlickgridModule,
  Column,
  GridOption,
  SlickGrid,
} from 'angular-slickgrid';
import { DataTableHelperService } from '../services/data-table-helper';
import { localizeWithFallback } from '../utils/localization-utils';

@Component({
  selector: 'app-search-result-table',
  imports: [AngularSlickgridModule],
  providers: [DataTableHelperService],
  templateUrl: './search-result-table.html',
  styleUrl: './search-result-table.scss',
})
export class SearchResultTable implements OnInit {
  private readonly helper = inject(DataTableHelperService);
  private readonly localizationService = inject(LocalizationService);

  columnDefinitions = input<Column[]>([]);
  extraOptions = input<GridOption>({});
  dataset = input<any>([]);
  /** Unique grid identifier. Defaults to 'grid1' for backwards compatibility */
  gridId = input<string>('grid1');
  gridOptions: GridOption;

  gridCreated = output<SlickGrid>();
  angularGridReady = output<any>();

  ngOnInit(): void {
    const emptyTitle = localizeWithFallback(
      this.localizationService,
      'LanguageService::EmptySearchResultTitle'
    );

    this.gridOptions = {
      enableAutoResize: true,
      enableSorting: true,
      gridWidth: '100%',
      locales: this.helper.getGridLanguage(),
      enableEmptyDataWarningMessage: true,
      emptyDataWarning: {
        message: (() => {
          const wrapper = document.createElement('div');
          wrapper.innerHTML = `
            <img src="assets/images/no-results.svg" width="120" alt="Sin datos" />
            <h4>${emptyTitle}</h4>
          `;

          const slickViewport = document.querySelector('.slickgrid-container');
          const viewportWidth = slickViewport
            ? slickViewport.getBoundingClientRect().width
            : window.innerWidth;
          wrapper.style.width = `${viewportWidth}px`;

          return wrapper;
        })(),
        className: 'empty-grid-warning',
        leftViewportMarginLeft: '0',
        rightViewportMarginLeft: '0',
      },
      ...this.extraOptions(),
    };
  }

  gridReady(grid: SlickGrid) {
    this.gridCreated.emit(grid);
  }

  onAngularGridReady(grid: any) {
    this.angularGridReady.emit(grid.detail);
  }
}
